import { isUndefined } from 'ramda-adjunct'

export const getYoutubeIframeApiSingleton = async (): Promise<typeof window.YT> => {
  if (!isUndefined(window.YT)) return window.YT

  const YoutubeIframePromise = new Promise<typeof window.YT>((res) => {
    ;(window as any).onYouTubeIframeAPIReady = () => res(window.YT)
  })

  const tag = document.createElement('script')
  tag.src = 'https://www.youtube.com/iframe_api'
  document.head.append(tag)

  return await YoutubeIframePromise
}
